// extracted by mini-css-extract-plugin
module.exports = {"uspFaqWrapper":"UspFaqWrapper_uspFaqWrapper__TtgW6"};